import { endPoints, requestType } from "../constants/variables";
import Api from "./index";

export const createTask = (params) => {
  return Api(endPoints.createWorkerTask, params, requestType.POST);
};

export const updateTask = (id, params) => {
  return Api(`${endPoints.jobUpdate}/${id}`, params, requestType.PUT);
};

export const getAllTasks = () => {
  return Api(endPoints.fetchAllTasks, null, requestType.GET);
};

export const getTaskDetail = (id) => {
  return Api(`${endPoints.jobDetail}/${id}`, null, requestType.GET);
};

export const getTaskStats = () => {
  return Api(endPoints.taskStats, null, requestType.GET);
};

export  const taskDelete = (id) => {
  return Api(`${endPoints.jobDelete}/${id}`, null, requestType.DELETE);
};

export const getSubmittedImages = (id, workerId) => {
  return Api(`${endPoints.getSubmittedImages}/${id}/${workerId}`, null, requestType.GET);
};

export const getTaskSubTasks = (jobId, subTaskId) => {
  const query = subTaskId ? `?subTaskId=${subTaskId}` : "";
  return Api(`${endPoints.viewJobSubTasks}/${jobId}${query}`, null, requestType.GET);
};

export const addTaskSubTask = (jobId, subTaskPayload) => {
  return Api(
    `${endPoints.addJobSubTask}/${jobId}`,
    { subTask: subTaskPayload },
    requestType.POST
  );
};

export const removeTaskSubTask = (jobId, subTaskId) => {
  return Api(
    `${endPoints.removeJobSubTask}/${jobId}`,
    { subTaskId },
    requestType.DELETE
  );
};
